import { StaticPageLayout } from '@/components/layout/StaticPageLayout';

export function CookiesPage() {
 return (
  <StaticPageLayout title='Cookies Policy' lastUpdated='2024-03-15'>
   <p>
    This Cookie Policy explains how MOCK.SYSTEM uses cookies and similar
    technologies to recognize you when you visit our website.
   </p>

   <h3>What are cookies?</h3>
   <p>
    Cookies are small data files that are placed on your computer or mobile
    device when you visit a website. Cookies are widely used by website owners
    in order to make their websites work, or to work more efficiently, as well
    as to provide reporting information.
   </p>

   <h3>Why do we use cookies?</h3>
   <p>
    We use first-party and third-party cookies for several reasons. Some cookies
    are required for technical reasons in order for our Website to operate, and
    we refer to these as "essential" or "strictly necessary" cookies. Other
    cookies also enable us to track and target the interests of our users to
    enhance the experience on our Online Properties.
   </p>
  </StaticPageLayout>
 );
}
